import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ResellerLayout from '@/components/reseller/ResellerLayout';
import ResellerDashboard from '@/pages/reseller/ResellerDashboard';
import ResellerOrdersPage from '@/pages/reseller/ResellerOrdersPage';
import ResellerNewOrderPage from '@/pages/reseller/ResellerNewOrderPage';
import ResellerLicensesPage from '@/pages/reseller/ResellerLicensesPage';
import ResellerCustomersPage from '@/pages/reseller/ResellerCustomersPage';

const ResellerRoutes: React.FC = () => (
  <Routes>
    <Route element={<ResellerLayout />}>
      <Route path="/" element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<ResellerDashboard />} />
      <Route path="orders" element={<ResellerOrdersPage />} />
      <Route path="orders/new" element={<ResellerNewOrderPage />} />
      <Route path="licenses" element={<ResellerLicensesPage />} />
      <Route path="customers" element={<ResellerCustomersPage />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Route>
  </Routes>
);

export default ResellerRoutes;
